import { graphql } from 'react-relay';

export const subscriptionIntroductionFragment = graphql`
    fragment SubscriptionIntroduction_component on SubscriptionIntroduction {
        title
        longtext
    }
`;
